import type { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import OtpInput from 'react-otp-input';
import { cn } from '../../utils';
import { Button } from './button';

export interface OtpProps {
  numInputs: number;
  onChange: (value: string) => void;
  value: string;
  handleSubmit: () => void;
  error: string | null;
}

export function Otp({
  numInputs,
  onChange,
  value,
  handleSubmit,
  error,
}: OtpProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
      className={cn('flex flex-col items-center space-y-4')}
    >
      <OtpInput
        shouldAutoFocus
        value={value}
        onChange={onChange}
        numInputs={numInputs}
        inputStyle={cn(
          'h-full !w-full text-default-gray-950 rounded-2xl border-2 font-bold cursor-pointer p-2.5',
          {
            'border-red-500': error,
          },
        )}
        containerStyle={cn(
          'gird gap-[10px] sm:text-5xl text-3xl sm:gap-[20px]',
        )}
        renderInput={(props: InputHTMLAttributes<HTMLInputElement>) => (
          <input {...props} />
        )}
      />
      {error && <span className="font-medium text-red-500">{error}</span>}
      <Button
        type="submit"
        disabled={value.toString().length !== numInputs}
        onClick={handleSubmit}
        as="button"
      >
        {t('otp.submit')}
      </Button>
    </form>
  );
}
